import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const ec2Option: Option<CriteriaKey> = {
  name: 'Amazon EC2',
  description:
    'Provides resizable compute capacity in the cloud. You can use EC2 to launch instances that have the computing power, memory, storage, and networking capacity that you need for your applications.',
  tags: ['Virtual Machines', 'Servers'],
  pros: ['Scalable', 'Reliable', 'Secure'],
  cons: ['Cost-optimization', 'Management overhead'],
  documentationLink: 'https://aws.amazon.com/ec2/',
  criteriaScores: {
    asyncExecution: { score: { value: 1 } },
    scalability: { score: { value: 3 } },
    unlimitedExecutionTimeout: { score: { value: 10 } },
    storagePersistance: { score: { value: 10 } },
    vendorLockIn: { score: { value: 10 } },
    containerizationLimitations: { score: { value: 10 } },
    operationalManagement: { score: { value: 10 } },
    etlOriented: { score: { value: 1 } },
    batchingProcessing: { score: { value: 1 } },
  },
};
